import { FC } from "react";

const BRAND = "#2563eb";

interface Feature {
  icon: string;
  bg: string;
  title: string;
  desc: string;
  link: string;
}

const features: Feature[] = [
  {
    icon: "✏️",
    bg: "#dbeafe",
    title: "Work directly on your files",
    desc: "Highlight and add text, images, shapes, and freehand annotations to your documents. Connect to 10+ tools to enhance further.",
    link: "Edit a PDF now",
  },
  // {
  //   icon: "✍️",
  //   bg: "#dcfce7",
  //   title: "Digital signatures made easy",
  //   desc: "Fill in forms, e-sign contracts, and close deals in a few simple steps. Request e-signatures and track progress every step of the way.",
  //   link: "Try eSign",
  // },
  {
    icon: "🛠️",
    bg: "#fef9c3",
    title: "Create the perfect document",
    desc: "File too big? Compress it. Need a specific format? Convert it. Things getting chaotic? Merge and split files, or remove excess pages.",
    link: "View all PDF tools",
  },
  // {
  //   icon: "🤖",
  //   bg: "#ede9fe",
  //   title: "AI-powered PDF assistant",
  //   desc: "Chat with your PDF, get instant summaries of long documents, and translate content into any language in seconds.",
  //   link: "Try AI PDF",
  // },
  {
    icon: "📱",
    bg: "#ffedd5",
    title: "Work anywhere, any device",
    desc: "Create PDF scans, organize documents, and share files across all your connected devices with the EasyPDF Mobile App.",
    link: "Get mobile app",
  },
  {
    icon: "🗂️",
    bg: "#fee2e2",
    title: "Manage documents in one place",
    desc: "No more working across multiple apps! Save time by storing, managing, and sharing files across devices from our web platform.",
    link: "Start organizing",
  },
];

const FeaturesSection: FC = () => {
  return (
    <div style={{ padding: "52px 40px" }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 6 }}>Keep your simple tasks simple</h2>
      <p style={{ fontSize: 15, color: "#888", marginBottom: 40 }}>
        Everything you need to manage digital documents — in one place.
      </p>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: 32,
      }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{
              width: 52, height: 52, borderRadius: 14,
              background: f.bg,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 26,
            }}>
              {f.icon}
            </div>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: "#1a1a1a" }}>{f.title}</h3>
            <p style={{ fontSize: 14, color: "#666", lineHeight: 1.7 }}>{f.desc}</p>
            <a href="#" style={{
              fontSize: 13, color: BRAND, fontWeight: 600,
              display: "flex", alignItems: "center", gap: 4,
              transition: "gap 0.15s",
            }}
              onMouseEnter={(e) => e.currentTarget.style.gap = "8px"}
              onMouseLeave={(e) => e.currentTarget.style.gap = "4px"}>
              {f.link} →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;

